/* ---------------- DISTANCE FUNCTION ---------------- */
export const distanceKm = (lat1, lon1, lat2, lon2) => {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) *
    Math.cos((lat2 * Math.PI) / 180) *
    Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};


/* ---------------- DELIVERY SETTINGS ---------------- */
export const MAX_RADIUS_KM = 6;

export function calculateDeliveryTime(distanceKm) {
  if (distanceKm <= 1) return 25;
  if (distanceKm <= 3) return 30;
  if (distanceKm <= 5) return 40;
  if (distanceKm <= 7) return 50;
  return 60;
}

export async function getAddressFromLatLng(lat, lng) {
  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`,
      {
        headers: {
          "Accept": "application/json",
          // IMPORTANT for Nominatim usage policy
          "User-Agent": "KamuskaApp/1.0 (contact@kamuska.com)",
        },
      }
    );

    if (!res.ok) throw new Error("Reverse geocode failed");

    const data = await res.json();

    return (
      data.display_name ||
      data.name ||
      "Selected Location"
    );
  } catch (err) {
    console.error("Reverse geocoding error:", err);
    return "Selected Location";
  }
}


/* ---------------- BASE (OUTLET) ---------------- */
export const BASE = {
  lat: 18.6702551,
  lng: 73.7846511,
};

export function shortAddress(address = "", targetIndex = 30) {
  if (!address) return "loading";

  if (address.length <= targetIndex) return address;

  // Find nearest comma before and after target index
  const before = address.lastIndexOf(",", targetIndex);
  const after = address.indexOf(",", targetIndex);

  let cutIndex;

  if (before === -1 && after === -1) {
    // No comma at all
    cutIndex = targetIndex;
  } else if (before === -1) {
    cutIndex = after;
  } else if (after === -1) {
    cutIndex = before;
  } else {
    // Pick nearest comma
    cutIndex =
      targetIndex - before <= after - targetIndex ? before : after;
  }
  var add = address.slice(0, cutIndex);
  if (add.length > 40) {
    add = add.slice(0, 35)
  }
  return add;
}

export const google_map_api = "AIzaSyAn_sSU2xwAaL8S6SFJszMXpyHinHn3qwg"

export const getUserIP = async () => {
  const res = await fetch("https://api.ipify.org?format=json");
  const data = await res.json();
  return data.ip;
};

export const getDeviceInfo = () => {
  const ua = navigator.userAgent;

  let device = "Desktop";
  if (/android/i.test(ua)) device = "Android";
  else if (/iphone|ipad|ipod/i.test(ua)) device = "iOS";

  let browser = "Unknown Browser";
  if (ua.includes("Chrome")) browser = "Chrome";
  else if (ua.includes("Firefox")) browser = "Firefox";
  else if (ua.includes("Safari") && !ua.includes("Chrome")) browser = "Safari";
  else if (ua.includes("Edg")) browser = "Edge";

  return `${device} • ${browser}`;
};


export function formatETA(minutes) {
  if (!minutes || minutes <= 0) return "—";

  if (minutes < 60) {
    return `${minutes} min`;
  }

  const hrs = Math.floor(minutes / 60);
  const mins = minutes % 60;

  if (mins === 0) {
    return `${hrs} hr`;
  }

  return `${hrs} hr ${mins} min`;
}

